import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

export default function HeadingWithAnimation({
  title,
  gradientText,
  description,
  threshold = 0.5,
  triggerOnce = true,
  animationClass = "slide-in-left",
  className = "",
}) {
  const [isVisible, setIsVisible] = useState(false);
  const { ref, inView } = useInView({ triggerOnce, threshold });

  useEffect(() => {
    setIsVisible(inView);
  }, [inView]);

  return (
    <div
      ref={ref}
      className={`mx-auto mb-8 text-center ${
        isVisible ? animationClass : ""
      } ${className}`}
    >
      <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
        {title} <span className="animate-gradient">{gradientText}</span>
      </h2>
      {description && (
        <p
          className="text-lg dark:text-jacarta-300"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </div>
  );
}
